export enum ScrollDirection {
  Down = 'scroll down',
  Up = 'scroll up',
}
